var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"img-box",class:[
            { 'show-border': item && item.middle },
            { love1: item && item.love == 1 },
            { love2: item && item.love == 2 } ],on:{"click":function($event){return _vm.clickItem(item, index)}}},[(item && item.love != 2)?[_c('img',{staticClass:"img",attrs:{"src":require('@/assets/icons/' +
                        (item.status == 'LK'
                            ? 'select'
                            : item.select
                            ? 'my-select'
                            : 'default-' +
                              (item.areaPriceIndex > 2 ? 2 : item.areaPriceIndex)) +
                        (item.love == 1
                            ? '-love-left'
                            : item.love == 2
                            ? '-love-right'
                            : '-default') +
                        '.png'),"alt":""}})]:_vm._e(),(!item)?_c('div',{staticClass:"none-bg"}):_vm._e()],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }